import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PricingPage from './PricingPage';
import SignupPage from './SignupPage';
import LoginPage from './LoginPage';
import SMSPlansPage from './SMSPlansPage';
import DynamicCMSPage from './DynamicCMSPage';
import InboxPage from './InboxPage';
import VerifyIdentityPage from './VerifyIdentityPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PricingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sms-plans" element={<SMSPlansPage />} />
        <Route path="/dynamic-cms" element={<DynamicCMSPage />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/verify-identity" element={<VerifyIdentityPage />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
